import React from 'react';

const indicatorStyles = {
  display: 'inline-block',
  margin: '0 8px',
  height: '9.6px',
  width: '9.6px',
  opacity: 0.3,
  backgroundColor: '#0075C9',
  borderRadius: '100%',
  bottom: '12px',
  cursor: 'pointer',
};

const renderIndicator = (
  onClickHandler: any,
  isSelected: boolean,
  index: number,
) =>
  isSelected ? (
    <li
      style={{
        ...indicatorStyles,
        backgroundColor: '#0075C9',
        opacity: 1,
      }}
    />
  ) : (
    <li
      style={indicatorStyles}
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      value={index}
      key={index}
      role="button"
      tabIndex={0}
    />
  );

export { renderIndicator };
